import React from 'react';
import { OfferCommonRejectionDrawer } from '@applicant-flow/components';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { PERFORM_EXTENSION_OFFER_ACTION_MUTATION } from '@working-experience/graphql/mutations';
import { OfferRejectionReasons } from '@common/graphql';

export const ExtensionOfferRejectionDrawer = ({
  open,
  onClose,
  extensionOfferId,
}: {
  open: boolean;
  onClose: () => void;
  extensionOfferId?: string;
}) => {
  const [performAction, { loading }] = useMutation(
    PERFORM_EXTENSION_OFFER_ACTION_MUTATION,
    {
      onCompleted() {
        createMessage('success', 'Extension Offer rejected');
        onClose();
      },
      onError: () => {
        createMessage(
          'error',
          'Extension Offer could not be rejected. Please try again or contact your hiring partner.'
        );
      },
    }
  );

  const onRejectClick = (
    reason: OfferRejectionReasons | null,
    rejectionDetails: string
  ) => {
    performAction({
      variables: {
        extensionOfferId: extensionOfferId || '',
        input: {
          action: 'reject',
          reason,
          rejectionDetails: rejectionDetails,
        },
      },
    });
  };

  return (
    <OfferCommonRejectionDrawer
      title="Reject Offer"
      open={open}
      onDrawerClose={onClose}
      onRejectClick={onRejectClick}
      buttonLoading={loading}
    />
  );
};
